<template>
  <div>
    <main id="default" class="defaultPage" v-if="Object.keys(defaultPage).length && currentLang">
      <section>
        <header>
          <h1>{{ defaultPage[currentLang].title }}</h1>
        </header>
        <div class="text--content" v-html="defaultPage[currentLang].text"></div>
      </section>
    </main>
    <ContactFooter :isLandingMounted="true" :displayLogo="true" :site="site"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');
import loaderHandler  from '@/mixins/loaderHandler.js'
export default {
  name: 'Default',
  computed: mapState(['defaultPage', 'site']),
  components: {ContactFooter},
  mixins: [loaderHandler],
  props:['currentLang'],
  created() {
    let path = this.$route.meta.frPath.split("/");
    path = path[2];
    this.$store.dispatch('loadDefaultPage', { path });
  },
  mounted(){
     this.$emit('mountedPage', {isBgLight : true});
  },
}
</script>

<style lang="scss">
  #default{
    background: var(--lighter--bgcolor);
    section{
      padding:10.5rem 1.4rem;
      min-height:calc(100vh - 15rem);
      color: var(--lightBgcolor);
      max-width:1300px;
      margin:auto;
      @media screen and (max-width:1024px){
        padding-left: 2rem;
        padding-right: 2rem;
      }
      header{
        padding:0;
        margin-bottom:1.7rem;
        h1{
          font-family: 'surtmedium_extended', helvetica, sans-serif;
          color: rgba(255,255,255,.7);
          font-size:1.067rem;
          letter-spacing:.4px;
        }
      }
    }

    .text--content{
      font-size:1.200em;
      line-height: 1.867rem;
      letter-spacing:.3px;
      @media screen and (min-width:768px){
        columns: 2 auto;
        column-gap: 80px;
      }
      h2{
        margin-top:2rem;
        display:block;
        text-decoration: underline;
        &:first-child{
          margin-top:0;
        }
      }
    }
  }
</style>